import React, { useState, useEffect } from 'react';
import { Input, List,  Spin, Typography,   Pagination, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import api from './api';
import QuestionItem from './Quiz/Fragments/QuestionItem';

const { Title, Paragraph } = Typography;

const Search = ({ analytics }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [query, setQuery] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (analytics) analytics();
    }, [analytics]);

    const handleSearch = (value) => {
        setQuery(value);
        setPage(1);
        performSearch(value, 1);
    };

    const performSearch = (q, p) => {
        if (!q) {
            setQuestions([]);
            setTotal(0);
            return;
        }
        setLoading(true);
        api.API.get(`api/questions?q=${q}&page=${p}`).then(res => {
            // The interceptor might have already returned res.data or the whole object
            // If it returned the whole paginated object:
            const data = res.data || res; 
            setQuestions(Array.isArray(data) ? data : (res.data || []));
            setTotal(res.total || 0);
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    };

    const onPageChange = (p) => {
        setPage(p);
        performSearch(query, p);
        window.scrollTo(0, 0);
    };

    return (
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}>
            <Helmet>
                <title>{t('header.search')} - AvtoDas</title>
            </Helmet>

            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <Title level={2}>{t('header.search')}</Title>
                <Input.Search
                    placeholder={t('header.search')}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="large"
                    onSearch={handleSearch}
                    loading={loading}
                    style={{ maxWidth: 600 }}
                />
            </div>

            <Spin spinning={loading}>
                {(questions && questions.length > 0) ? (
                    <>
                        <Paragraph type="secondary">
                            {t('search.found_count', { count: total })}
                        </Paragraph>
                        <List
                            dataSource={questions}
                            renderItem={(item) => (
                                <div style={{ marginBottom: 30 }}>
                                    <QuestionItem 
                                        currentQuestion={item} 
                                        noSubmit={true} 
                                    />
                                    <Divider />
                                </div>
                            )}
                        />
                        <div style={{ textAlign: 'center', marginTop: 20 }}>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={20}
                                onChange={onPageChange}
                                showSizeChanger={false}
                            />
                        </div>
                    </>
                ) : (
                    query && !loading && <div style={{ textAlign: 'center', marginTop: 40 }}>{t('search.not_found')}</div>
                )}
            </Spin>
        </div>
    );
};

export default Search;
